<template>
    <section role="status" class="stretchy-dot-container">
        <div class="relative">
            <div class="stretchy-dot"></div>
            <div class="stretchy-dot"></div>
            <div class="stretchy-dot"></div>
            <div class="stretchy-dot"></div>
        </div>

        <span class="text"
            :class="{ 'sr-only' : !showText }"
            role="alert" 
            aria-busy="true" 
            aria-live="polite">
            {{ dotsText }}
        </span>
    </section>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'StretchyDots',
        props: {
            text: {
                type: String
            },
            showText: {
                default: true
            }
        },
        data() {
            return {
                dotsText: this.text ?? 'Processing'
            }
        }
    });
</script>